import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from '../i18n/en.json';
import de from '../i18n/de.json';

const resources = {
  en: {
    translation: { ...en },
  },
  de: {
    translation: { ...de },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de',
    keySeparator: '.',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/i18n/{{lng}}.json?v={{cacheBust}}',
    },
  });

export default i18n;
